module.exports = __webpack_public_path__ + "img/medicare-urgent-care-clinic-logo.d959ebeb.png";